// extracted by mini-css-extract-plugin
module.exports = {"separator":"Separator_separator__S0Zau","withText":"Separator_withText__1UZR8","line":"Separator_line__5TISD","text":"Separator_text__kmrqq"};